import React from 'react';
import { Outlet } from 'react-router-dom';
import './singlePageContainer.css';

export default function SinglePageContainer() {
  return (
    <div className="singlePageContainer">
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
}
